import React from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import BannerPage from '../../Components/Banner'
import { Link } from 'react-router'
import DisplayEarthWork from './DisplayEarthWork'

const EarthWork = () => {
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">

            <Sidebar />
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                <TopHeader pageName="EarthWork" />
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    <BannerPage pageName={'earthworks'} />
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h2 className="text-2xl text-neutral-800">EarthWork</h2>
                            <p className="text-neutral-600">Manage concrete project entries and case studies</p>
                        </div>
                        <Link to='/earthworks/form' class="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
                            <i className="fa-solid fa-plus mr-2"></i>
                            Add New EarthWork
                        </Link>
                    </div>
                    <DisplayEarthWork />
                </div>
            </div>
        </div>
    )
}

export default EarthWork
